import { bg, enUS, nl, pl, tr } from 'date-fns/locale';

export const getDateFnsLocale = (language?: string) => {
  const code = (language || 'nl').split('-')[0].toLowerCase();
  switch (code) {
    case 'bg':
      return bg;
    case 'nl':
      return nl;
    case 'tr':
      return tr;
    case 'pl':
      return pl;
    default:
      return enUS;
  }
};
